module.exports = {
  businessNumber: '业务编号',
  businessType: '业务类型',
  mblNo: '主单号',
  customer: '委托单位',
  carrier: '承运人',
  vessel: '船名',
  shippingCompanyContractNo: '船公司约号',
  voyageFlight: '航次/航班',
  SeaPortOfLoading: '起运港/装货港(海港)',
  portOfDestination: '目的港',
  dischargingPortCode: '卸货港',
  dateOfDeparture: '开航日期',
  businessDate: '业务日期',
  businessReferenceNumber: '业务参考号',
  bookingAgent: '订舱代理',
  dateOfCreation: '创建日期',
  dateOfProof: '凭证日期',
  operation: '操作',
  sales: '销售',
  salesDepartment: '销售部门',
  CustomerService: '客服',
  Documents: '单证',
  accrued: '已计提',
  status: '状态',
  actualChargedWeight: '实际计费重量',
  profit: '利润',
  totalIncome: '总收入',
  totalCost: '总成本',
  closingAccountStatus: '结转状态',
  hasReceivable: '是否强制结转',
  profitExcludingTax: '利润(不含税)',
  totalIncomeExcludingTax: '收入(不含税)',
  totalCostExcludingTax: '成本(不含税)',
  profitClosingAccount: '待结转利润',
  totalIncomeClosingAccount: '待结转收入',
  totalCostClosingAccount: '待结转成本',
  hasReceivableTotal: '是否强制计提',
  profitCommission: '本次提成利润',
  totalIncomeCommission: '本次提成收入',
  totalCostCommission: '本次提成成本',
  provisionedStatus: '计提状态',
  refundCommission: '佣金',
  closingAccountRevenue: '已结转收入',
  closingAccountCost: '已结转成本',
  invoiceCost: '已收票成本',
  payablesWriteOfStatus: '应付核销状态',
  receivablesWriteOfStatus: '应收核销状态',
  payablesConfirmOfStatus: '应付费用确认状态',
  receivablesConfirmOfStatus: '应收费用确认状态',
  accrualDate: '计提日期',
  creator: '业务创建人',
  receivables: '应收',
  payables: '应付',
  englishDescriptionOfGoods: '英文品名',
  chineseDescriptionOfGoods: '中文品名',
  consignationCompany: '委托单位',
  settlementCompany: '结算单位',
  destinationAgent: '目的港代理',
  nominatedAgent: '指定货代理',
  destinationAgentShortName: '目的港代理(简称)',
  nominatedAgentShortName: '指定货代理(简称)',
  containerNo: '箱号',
  amountRange: '金额区间',
  profitRange: '利润区间',
  localAmountRange: '折合本位币金额区间',
  SubmissionDateTime: '提交时间',
  AuditDateTime: '审核时间',
  feeStatus: '费用状态',
  redChargesOrNot: '是否红冲',
  portOfLoading: '装货港/起运港',
  AirPortOfLoading: '装货港/起运港(空港)',
  seaportOfDischarge: '卸货港（海港）',
  airportOfDischarge: '卸货港（空港）',
  airportOfDestination: '目的港（空港）',
  operationDepartment: '操作部门',
  invoiceDate: '开票日期',
  invoiceDateAR: '应收开票日期',
  financialaDate: '财务日期',
  solicitationType: '揽货类型',
  warehouseNo: '进仓编号',
  itemNo: '项目编号',
  receivablesInvoicingStatus: '开票状态',
  receivablesInvoicingStatusAr: '应收开票状态',
  businessStatus: '业务状态',
  customJobType: '自定义业务类型',
  separateNumber: '分单号',
  containerDescription: '箱量描述',
  designationAgent: '指定货代理',
  masterBLFreightTerm: '主单运费条款',
  HBLFreightClause: '分单运费条款',
  IncoTerm: '贸易条款',
  FLCLType: '整拼类型',
  SeaExportFLCLType: '整拼类型(海出)',
  SeaImportFLCLType: '整拼类型(海进)',
  OperateType: '操作模式',
  AirExportOperateType: '操作模式(空出)',
  AirImportOperateType: '操作模式(空进)',
  UserDefinedField1: '自定义字段1',
  UserDefinedField2: '自定义字段2',
  UserDefinedField3: '自定义字段3',
  ManageAuditStatus: '利润审核状态',
  paymentRequestNumber: '付款申请号',
  placeOfDelivery: '交货地',
  changeState: '改单状态',
  grossProfitRate: '毛利率',
  railwayTransportLine: '航线（铁路）',
  route: '航线',
  exportLoadingPlan: '导出装板计划',
  exportSalesReport: '导出销售报表',
  moreOperations: '更多操作',
  routeOperation: '航线操作',
  completeBooking: '完成订舱',
  warehousing: '进仓',
  mountingBoard: '装板',
  pullGood: '拉货',
  applicationForFlightAdjustment: '申请调整航班',
  allocateFlights: '调配航班',
  confirmCabinAllocation: '确认配舱',
  cancelConfirmationOfCabinAllocation: '取消确认配舱',
  copyIncomingData: '复制进仓数据',
  otherRemarks: '其它备注',
  otherExpenses: '其它费用',
  delivery: '交货',
  deliveryAgent: '交货代理',
  uploadBoardPhotos: '上传打板照片',
  subLabel: '分标签',
  prefabricatedMasterOrder: '预制主单',
  prefabricationOrderSplitting: '预制分单',
  printMasterOrder: '打印主单',
  printSplit: '打印分单',
  track: '跟踪',
  takeOff: '起飞',
  arrival: '到港',
  Discharge: '卸船',
  billOfLadingInquiry: '提单查询',
  expandAll: '全部展开',
  putItAllAway: '全部收起',
  noBusinessFlight: '无业务航班',
  heavy: '重',
  takeOff2: '已起飞',
  arrivedAtPort: '已到港',
  size: '尺码',
  cabinAllocationStatus: '配舱状态',
  installationInstructions: '装板说明',
  photograph: '拍照',
  guanFeng: '关封',
  singleCopy: '联单',
  flightInformationEmpty: '航班信息为空.',
  lockFlight: '锁定航班',
  unlockFlight: '解锁航班',
  cabinAllocationStatusConfirmed: '票业务的配舱状态设置为已确认吗?',
  confirmationSucceeded: '确认成功!',
  confirmThis: '确认将这',
  cabinAllocationStatusUnconfirmed: '票业务的配舱状态设置为未确认吗?',
  hair: '毛',
  selectBookedOrder: '请选择要订舱的单子!',
  preprint: '预打印',
  undoPrinting: '撤销打印',
  temporaryStorage: '暂存',
  bookingNumber: '订舱号',
  bookingTime: '订舱时间',
  descriptionOfBookingResults: '订舱结果说明',
  declared: '已报关',
  enterDeliveryAgent: '请输入交货代理.',
  whetherTakePhotos: '是否拍照',
  siteRemarks: '现场备注',
  otherInstructions: '其他说明',
  enterBillOfLadingNumber: '请输入提单号.',
  takeoffTime: '起飞时间',
  deliveryTime: '交货时间',
  trackingFlight: '跟踪航班',
  trackingArrival: '跟踪到港',
  trackingDelivery: '跟踪交货',
  enterDepartureTime: '请输入起飞时间.',
  enterArrivalTime: '请输入到港时间.',
  enterDeliveryTime: '请输入交货时间.',
  receivingOutsideWarehouse: '收货(外仓)',
  warehousingTime: '进仓时间：',
  damagedAndDamp: '有破损受潮',
  photo: '照片',
  selectPhotos: '选择照片',
  deletePhotos: '删除照片',
  selectWarehousingDate: '请选择入库日期!',
  enterSubLabel: '录入分标签',
  receiptNo: '回单号',
  pleaseEnterSubLabel: '请输入分标签.',
  uploading: '上传中',
  oneFileVolumn2MB: '有1个文件体积超过2MB,不能进行上传.',
  failedDeleteFile: '删除文件失败！',
  uploadSucceeded: '上传成功',
  uploadFailed: '上传失败',
  uploadComplete: '上传失败',
  notExceed6Lines: '最大不能超过6行!',
  nodeName: '节点名称',
  nodeState: '节点状态',
  warningLevel: '预警级别',
  warningAt: '预警时间',
  line: '线路',
  airTransportArea: '空运区域',
  operationalResponsibilities: '操作职责',
  assignmentOfResponsibilities: '职责分配',
  roleList: '角色列表',
  assignedResponsibilities: '已经分配职责',
  listOfResponsibilities: '职责列表',
  NoVoucherGeneratedReceivable: '未生成凭证应收',
  NoVoucherGeneratedPayable: '未生成凭证应付',
  VoucherGeneratedReceivable: '已生成凭证应收',
  VoucherGeneratedPayable: '已生成凭证应付',
  TenTicketsAtTheSameTime: '最多可同时查看10票业务，请重新选择。',
  DataChangedToReopen: '数据已经被更改请重新打开后编辑。',
  JobOpenedAndCannotDelete: '该票业务已经打开了一个新页签，不能删除！',
  AreWantToDeleteBusiness: '请确定是否删除此票业务?',
  DoToDeleteTheTicket: '是否要删除小票?',
  AreToDeleteTheBusiness: '确定要删除当前选中的业务吗?',
  AreToConvertTheItem: '确定要转换当前选中的项吗？',
  ConversionSucceeded: '转换成功',
  OperationDepartmentCannotBeEmpty: '操作部门不能为空！',
  OrangeWorkingDaysFromETA: '橙色：距离ETA七个工作日以内',
  RedWorkingDaysFromETA: '红色：距离ETA三个工作日以内',
  BatchOfWholeSplicingType: '批量修改整拼类型:',
  UploadedOnlyBeInFormat: '上传文件只能是csv格式!',
  ThatSOk: '行',
  NotInPositiveOperation: '不是正操作状态.',
  AreTicketsSubmitted: '票进行提交吗?',
  IsTheTicketPreSubmitted: '票单子进行预提交吗?',
  AreWantToWithdrawTicket: '确定要撤回该票业务吗?',
  BillOfLadingInformationTracking: '提单信息跟踪',
  PleaseMaintainTheJumpAddress: '请维护跳转地址！',
  CannotBeEmpty: '不能为空',
  AreWantToRemoveTicket: '确定要移除该小票吗？',
  NoBusinessSelected: '未选择业务',
  IfForTheGoodsSame: '如果本票货物使用海外代理同船公司的约价，在此处打钩',
  EspeciallyPeersThatUBISpace: '特指UBI前去订舱的船公司或者同行',
  UnitKg: '单位： 公斤',
  UnitCubicMeter: '单位： 立方米',
  UnitTon: '单位： 吨',
  DoorNotBeenSavedPrinted: '尚未保存的门点信息不能打印！',
  CaseNo: '箱号为',
  AllTheAssociationDoContinue: '的数据都会被移除关联，需要继续吗',
  DetailsSeaborneExportGoodsXls: '海运出口货物明细.xls',
  FindTheTrailerLocationNow: '立即查询拖车位置',
  EstimatedLoadingDate: '预计装货日期',
  SelectDateAndTime: '选择日期时间',
  PrimaryDocNoAlreadyExists: '主单号已经存在',
  PleaseEnterTheFlightNumber: '请输入航班号.',
  PleaseEnterETD: '请输入ETD.',
  PleaseEnterAnAction: '请输入操作.',
  PleaseEnterTheRoute: '请输入航线.',
  AreWantToAllocateFlight: '确定要调配这【{0}】票业务的航班吗?',
  DeploymentSucceeded: '调配成功!',
  SuccessfullyPicturesAreYouSave: '成功上传:{0}个,失败:{1}个图片，确认要保存吗？',
  TheSelectedRecordMustSame: '所选记录的ETD必须相同！',
  TheSelectedRecordsMustSame: '所选记录的航空公司必须相同！',
  PleaseWithTheSameMode: '请选择操作模式一致的业务',
  SiruiPleaseContactTheTroubleshooting: '思锐委托单推送失败,请联系工作人员排查:',
  BusinessTodayIsNotCustoms: '开航日期大于今天的业务不允许退关',
  G7DataPush: 'G7数据推送',
  DropDown: '下拉',
  TheBeenAddedToOrder: '分单已经加入主单!',
  NotBoundYet: '还未绑定!',
  TheCostSharingAndSeparated: '当前小票有分摊费用,不能分离!',
  AreUnbindTheMasterOrder: '确定要解除与主票或主单的绑定吗？',
  PleaseEnterOperatorInformation: '请输入操作人员信息!',
  TheIsIllegalPleaseEnter: '主单号不合法，请重新输入!',
  PleaseTheDesignatedShippingAgent: '请输入指定货代理!',
  TheseWillBeSetJoin: '这些字段与主票不同，如果要加入主票会被设置为与主票相同，确认要加入吗？',
  TheNotExceed6Lines: '最大不能超过6行！',
  TheNotExceed7Lines: '最大不能超过7行！',
  ThereMasterTicketThisPerformed: '主票中有费用，不能进行此操作！',
  TheTicketIfYouSwitch: '小票已经与主票绑定且主票下只有一个小票,如果要切换操作模式主票会被删除!确认要切换吗?',
  TheTheBindingRelationshipSwitch: '小票已经与主票绑定,如果切换操作模式会解除与主票的绑定关系!确认要切换吗?',
  SwitchAMasterTicketSwitch: '切换到一主多分工作模式，系统装自动创建一张主票与当前票绑定!确认要切换吗?',
  DateExceededCreditControl: '合作伙伴 账期 已经超出！',
  AmountExceededCreditControl: '合作伙伴 额度 已经超出！',
  DateAndAmountExceededCreditControl: '合作伙伴 额度 账期 已经超出！',
  ThisHasExceededCreditControl: '此合作伙伴已超信控',
  ItAEntrustingUnitAgent: '不可作为委托单位或指定货代理',
  ThisHasBeenAutomaticallyCleared: '已自动清空此栏',
  JoinTheTicketSuccessfully: '加入小票成功！',
  ThereSplitTicketTheTicket: '当前主票只有一个分票，如果要移出分票，主票会被自动移除，确定要移出分票吗？',
  TheTicketHasBeenRemoved: '主票已经被移除!',
  AreRemoveThisSubTicket: '确定要从主票中移出该分票吗',
  AttachmentDescription: '附件说明',
  AirlineCachePleaseResetAgain: '缓存中未找到航空公司信息,请重置缓存在试试',
  ResettingTheModifiedContentContinue: '重置初始值将覆盖已经修改的内容，是否继续？',
  PleaseEnterTheSplitNumber: '请输入分单号码',
  AlreadyExists: '已经存在!',
  DetailsAirExportGoodsXls: '空运出口货物明细.xls',
  PleaseSelectWarehousingData: '请选择进仓数据！',
  AreToDeleteThisData: '确定删除本条进仓数据？',
  TheRateMAndAdjusted: 'TOTAL值小于维护的运价M，不能调整运价相关信息！',
  AirlineInformation: '航空公司信息',
  PleaseSelectAFee: '请选择一条费用',
  SelectMainOrder: '选择主单',
  ManualInput: '手动输入：',
  TheOrderNumberIsIllegal: '主单号不合法！',
  WarehousingInstructions: '进仓说明',
  OtherInstructions: '其他说明：',
  GoodsIntoThisWarehouse: '货进本仓',
  NeedPhotos: '需要照片',
  AttachedDocuments: '附随机文件',
  Generate: '生成',
  Save: '是否保存?',
  PleaseTheEstimatedWarehousingTime: '请输入预计进仓时间！',
  AirlineCompany: '航空公司:',
  Flight: '航班:',
  FieldOperation: '现场操作:',
  SendFieldOperation: '发送现场操作',
  EntrustedWeight: '委托重量',
  NumberOfBookingPieces: '订舱件数',
  BookingWeight: '订舱重量',
  BookingVolume: '订舱体积',
  PleaseFillInTheFlight: '请填写航班!',
  PromissoryHaveBecomeOfficialBusiness: '本票已是正式业务.',
  ThisApprovalStatusAndEdited: '此单已进入财务审批状态, 不能被编辑。',
  AreToConvertTheItem2: '确定要转换当前选中的项吗?',
  TheDoesNotComplyRules: '主单号不符合规则!',
  DoubleOfLadingHeaderUp: '提单抬头双击弹出',
  SmallNumberOfVotes: '小票数',
  NumberOfPrimaryVotes: '主票数',
  ThePleaseMaintainTheFirst: '主单号为空，请先维护主单号',
  TheTheNewlySelectedContinue: '新选小票的航班号，航空公司,开航日期，到港日期，主单放货方式和主单运费条款与主票不一致。系统将修改小票。是否继续？',
  ClickSelectTheGoodsCode: '敲空格选择货物大类CODE',
  AreSureVoidThisTicket: '确定要作废该票业务吗？',
  AllChargesBeDeleted: '所有费用会被删除！',
  SellingPriceCalculationCompleted: '卖价计算完成',
  OperationOfTicketCannotEdited: '你不是该票的操作，不能编辑。',
  ActualNotifierCannotBeBlank: '实际通知人不能为空',
  SpecifiedFreightAgentCannotEmpty: '指定货代理不能为空',
  ArrivalDateCannotBlank: '到港日期不能为空',
  OperationDepartmentCannotBlank: '操作部门不能为空',
  ExpectedArrivalDateCannotBlank: '预计到港日期不能为空',
  PleaseReselect: '请重新选择',
  EstimatedProfitNotCompanyRegulations: '本票业务预估利润不符合公司规定{0}之间，是否确认保存？',
  ReceivableExpensesMustBeEntered: '应收费用必须录入。',
  PayableExpensesMustBeEntered: '应付费用必须录入。',
  BlockedCannotUsedContactCustomerManagement: '[{0}]已被屏蔽,不能使用请与本公司客户管理人员联系.',
  // REQ-0005 风控提示优化：合作伙伴被屏蔽（带停用原因）
  CompanyBlockedCannotUsedWithReason: '[{0}]已被屏蔽,停用原因[{1}].',
  // REQ-0005：停用原因(inactiveReason)为空时
  CompanyBlockedCannotUsed: '[{0}]已被屏蔽.',
  exportOption: '导出选项',
  exportDescription: '导出描述',
  dataNotMerged: '数据不合并',
  noMoreReminders: '不再提醒',
  UsCustomsClearance: '美国清关',
  CustomerInformation: '客户资料',
  DeclarationMaterials: '申报资料',
  TopSecretInformation: '绝密资料',
  DeletionIsUnrecoverable: '删除操作不可恢复，请确认是否删除数据？',
  PleaseEnterOnLine: '请输入第{0}行的{1}',
  CustomerName: '客户品名',
  CustomsClearanceProductName: '清关品名',
  NumberOfPackages: '包装数',
  NumberOfGoods: '货物件数',
  CustomsClearanceUnit: '清关单位',
  Export7501: '导出7501',
  ExportInvoicePackingList: '导出发票箱单',
  GenerateReceivableExpense: '生成应收费用',
  GeneratePayableExpenses: '生成应付费用',
  CopyAsCustomerData: '复制为客户资料',
  CopyAsDeclarationData: '复制为申报资料',
  CopyAsTopSecretInformation: '复制为绝密资料',
  PdfType: 'PDF 类型',
  MergeProductNamesWhenFiles: '生成文件时合并同品名',
  ShowTax: '显示税费',
  ShowChinaSurtax: '显示中国附加税',
  ShowMargin: '显示保证金',
  MarginAmount: '保证金金额',
  TotalNetWeight: '总净重',
  TotalValue: '总货值',
  TotalTariff: '关税合计',
  TotalOtherExpenses: '其他费用合计',
  UnitWeight: '单件货重',
  ItemPricing: '商品单价',
  TotalPriceOfGoods: '商品总价',
  ChinaAdditionalTaxRate: '中国附加税率',
  ChinasSurtaxTariff: '中国附加税税则',
  ChinaSurtaxClause: '中国附加税条款',
  AccountsReceivableGeneratedSuccessfully: '应收费用生成成功。',
  PayableExpensesGeneratedSuccessfully: '应付费用生成成功。',
  ThePleaseConfirmWhetherData: '清空操作不可恢复，请确认是否清空数据？',
  TheSureYouWantData: '删除操作不可恢复，请确认是否删除该行数据？',
  BusinessDateChangedUpdateExchangeRate: '业务日期已变更，请注意更新费用汇率',
  CustomsClearance: '清关',
  QuantityIsInconsistentOfEqSizeType: '【{eqSize}{eqType}】箱量和装箱信息数量不一致',
  QuantityIsInconsistentOfCodeType: '【{containerCode}{containerType}】箱量和装板信息数量不一致',
  syncChargesToExportJobMessage: '共同步{total}条信息，成功{successCount}条，失败{failCount}条',
  syncChargesToExportJobFailMessage: `<span>同步<span style="color:blue">{total}</span>条费用</span>，成功<span style="color:green">{successCount}</span>个，失败<span style="color:red">{failCount}</span>个</span><br/>
  <b>原因如下</b><br/>`,
  ImportReceivablePpayableObjectNotEqualCustomer: '费用{no}：进口应收/应付费用结算对象!=出口方（委托单位）',
  BillGenerated: '费用{no}：已生成账单',
  InvoiceIssued: '费用{no}：已开票',
  AccountWrittenOff: '费用{no}：已销账',
  PaymentApplication: '费用{no}：已付款申请',
  ExpenseConfirmationYes: '费用{no}：费用确认-是',
  ExpenseStatusSubmitted: '费用{no}：费用状态-已提交',
  CollectionAdvancePayment: '费用{no}：已代收垫付',
  ExpensesGeneratedByVarianceProcessing: '费用{no}：属于差额处理产生的费用',
  Shared: '费用{no}：已分摊',
  NotOperatingCannotSynchronized: '非正操作订单无法进行同步操作',
  ImportHasSynchronizedDispatchingInformation: '<b style="font-size:16px">进口订单已同步派车信息</b><br><span style="font-size:16px">你还要继续吗？</span>',
  MatchingConditionsForPushSOPReceiver: '推送SOP接收人匹配条件',
  GenerateXChargeSyncRecords: '生成{num}条费用同步记录',
  Density: '密度',
  CommissionedDensity: '委托密度',
  ActualDensity: '实际密度',
  EstimatedReviewer: '预审审核人',
  DateOfPreReview: '预审审核日期',
  EnteredXNotMatchAirlineCode: '录入的航班代码{0}与航空公司Airline Code不匹配',
  EnteredXNotMatchAirlinePrefix: '录入的主单号前三位{0}与航空公司MAWB Prefix不匹配',
  HasPackingFeeEnterWarehouse: '有装箱费用，请输入仓库信息!',
  SuccessSyncInfo: '同步信息成功',
  Search: '查询',
  Clear: '清空',
  ShipperName: '发货人名称',
  ConsigneeName: '收货人名称',
  NotifyPartyName: '通知人名称',
  AfterToBeRevokedSynchronize: '确定同步之后不允许再撤销，是否确认同步？',
  PleaseADataToDelete: '请选择一条数据进行删除！',
  CreatePaymentRequestSelectFee: '创建付款申请-选择费用',
  PleaseSelectTheBill: '请选择账单.',
  YouViewOrPrintOthers: '你没有查看其它人上传或者打印的文件的权限.',
  AgentCommissionBill: '代理分成账单',
  TheWithdrawnAndCannotOperated: '业务已退关，不能操作',
  PleaseSelectTheForeignBill: '请选择国外账单.',
  Equivalent: '折合',
  EquivalentToRMB: '折合RMB',
  OperationFailed: '操作失败',
  FrontEndErrorCallbackFailed: '前端error：回调失败',
  YouToEditTheAdministrator: '您没有编辑数据的相应权限,请联系管理员',
  UploadingPleaseWait: '上传中,请稍等......',
  AssociateBusinessSOPNode: '关联业务sop节点',
  CustomsDuty: '关税',
  AddAmendmentFee: '新增改单费用',
  AddNewBusiness: '新增业务',
  Add: '新增',
  Maintain: '保持',
  Modify: '修改',
  PleaseEnterTheBusinessNumber: '请输入业务编号!',
  ReceiptSuccessful: '回执成功',
  WaitingForReceipt: '等待回执',
  SaveSuccessfully: '保存成功',
  SendEmail: '发送邮箱',
  SystemEmail: '系统邮箱',
  CompanyEmail: '公司邮箱',
  PersonalEmail: '个人邮箱',
  Submitted: '已提交',
  DataSource: '数据来源',
  SystemInput: '系统录入',
  PortAreaData: '港区数据',
  UpdateToPortAreaData: '更新为港区数据',
  NewExportClearancePolicy: '出口放行新规',
  YangshanAreaNovember152021: '洋山关区：2021年11月15号',
  WaigaoqiaoAreaNovember222021: '外港关区：2021年11月22号',
  GarbageManifest: '垃圾舱单',
  N1OnceTheManifestManifest: '1.垃圾舱单海关严令禁止！根据海关规定，每一票预配舱单，必须对应一票实际的出运货物。舱单发送后，如果您的货物未出运（未赶上船、出货计划变更等原因），该票舱单即视为垃圾舱单！',
  N2ManifestMustBeDeletion: '2.垃圾舱单情况举例：船舶改配后，原预配舱单一定要删除，删除后才能发送新预配舱单！',
  N3YuanOnTheManifest: '3. 垃圾舱单未删除后果：不仅会影响装船，海关最高也可对货代施以50000元罚金并取消报关资格！出现垃圾舱单后，请及时联系客服协助删除垃圾舱单！',
  BusinessUUIDCannotBeEmpty: '业务UUID不能为空！',
  BillUUIDCannotBeEmpty: '账单UUID不能为空！',
  FileInformation: '文件信息',
  BillingInformation: '账单信息',
  DomesticWarehouse: '国内仓',
  ForeignWarehouse: '国外仓',
  ExpectedTimeAtAmazonWarehouse: '预期入亚马逊仓时间',
  ReferenceBoxNumber: '参考箱号',
  TotalDoesNotEqualCost: '小票分摊费用总和与原始费用不相等!',
  NameCannotBeEmpty: '姓名不能为空！',
  SOPOperationStatus: 'SOP操作状态',
  AddSpecialFees: '新增特殊费用',
  TrailerTrackingUsageNotice: '拖车追踪使用告知书',
  N1SituationIncludingButDepartments: '1.根据国家相关法律规定，系统有义务记录用户的查询情况，包括但不限于（查询的车牌号，查询操作人，查询时间），以便在有关部门要求取证时提供相应证据备查。',
  N2ConsentBeforeQueryingCommunication: '2.根据国家相关法律规定，查询车辆位置前请务必征得车主的同意，用户应提前和车主沟通取得授权以避免出现侵权的行为。',
  N3TheOwnersConsentConsequences: '3.如用户在未征得车主同意时查询车辆信息，由此带来的法律责任将由用户自行承担。',
  N4ItToIrrelevantUser: '4.如用户已获得车主授权，也请注意在授权范围内使用信息，不得超出范围或泄漏给不相干的第三方，如由此带来的法律责任将由用户自行承担。',
  N5SystemCannotGuaranteeResponsibility: '5.受限于外部因素的不可控性（如GPS设备故障），系统无法保证查询结果必然准确，用户需明确并理解系统不对查询结果的准确性负任何责任。',
  N6BeAwareOfHome: '6.由于目前拖车追踪是通过第三方（鸭嘴兽）合作一起提供的服务，用户在使用服务时即允许第三方知晓您的存在并可能联系您，此并非由于CargoWare/沃联之家泄露您的资料所引起的。',
  DoNotRemindMeAgain: '下次不再提醒',
  IUnderstoodAndConfirmContinuing: '我已知晓，确认继续',
  ImportModeTip: '导入类型为修改，为系统分别根据关单号、箱号、封号、箱型、箱种帮您匹配到与港区一致的数据。\n导入类型为保持，为您录入的数据未匹配到港区数据，即为您原始录入数据。',
  NewExportClearancePolicyTip: '上海海关172号令切换放行条件，凭“装载舱单”回执向码头传输海放信息，请客户报关完成后自行关注装载舱单状态，异常情况及时联系客服确认。届时，拼箱内冗余舱单未及时删除、落货不及时、放行后加拼不规范、舱单数据修改不成功、混拼、提单号在两年内重复使用都会影响装船。其次，装载舱单接收到正常回执后，如遇到任何预配舱单需要修改、删除或新增舱单的情况，需先联系船代删除装载舱单后继续操作。',
  Upload0UploadFailed0: '上传成功:{0}个,上传失败:{1}个.',
  CustomerBranchScopeNot: '【委托单位】归属分公司不正确，请重新选择保持一致。',
  BatchInitiateCollaboration: '批量发起协作',
  OrderCenterBranchNotAvailable: '{0}是接单分公司，但未开启接单分公司配置',
  BatchCollaboration: '批量协作',
  SuccessCooperateX: '成功协作{0}条业务',
  SuccessCooperateXFailY: '成功协作{0}条业务，失败{1}条 失败原因：',
  BusinessIsMaster: '业务{0}为主票',
  NotBranchCollaborationManageme: '业务{0}不是接单分公司，也没有操作公司协作管理权限',
  OpOfficeNotCooperateBranch: '业务{0}操作公司不能是协作分公司',
  ExistCollaborationBranchRecord: '业务{0}已存在接受分公司是{1}的协作记录',
  EntrustedRecipient: '委托接收人',
  NoteConsigneeCustomerExportImport: '注：当出口“收货人”对应进口“委托单位”时，请确保此合作伙伴存在“客户”角色！！',
  SetAsDefaultExportInfo: '将本次内容设置为默认转出口信息',
  RecipientNotExist: '当前收货人不存在',
  ConsigneeCustomerNotExist: '当前收货人不存在“客户”角色，无法当作委托单位使用，请前往合作伙伴模块维护信息后再进行重试',
  CurrencyChangeCheckDiff: 'Currency字段调整为：{0} ，请注意【Prepaid】【Collect】和【Other Charge】等对应货币的小数位数。',
  InvalidBillCannotConfirm: '存在作废状态的账单无法确认，请确认',
  Reviewed: '已复核',
  ApplicationPayInitiated: '已发起申请付款',
  NotPrintedState: '不是已打印状态',
  StatementGenerated: '已生成对账单',
  NotUnapproved: '不是未审批',
  BillCannotVoid: '{0}账单{1}不能作废，请确认',
  SwitchHQNotView: '您已切换到HQ分公司无权限查看详情页，需退回列表页重新查询',
  JumpListPage: '跳转列表页',
  WhenDepartmentBranchNewSelection: '当业务的销售/单证/客服人员所在部门或分公司与原单据不一致时，需要重新选择！',
  OneClickQuery: '一键查询',
  PreSubimtCheckTip: '注:业务预提交后将不允许修改, 待全部订单完成提交后，可以通过下方"一键查询"按钮进行失败订单查询。',
  SubimtCheckTip: '注:业务提交后将不允许修改, 待全部订单完成提交后，可以通过下方"一键查询"按钮进行失败订单查询。',
  FinanceAuditCheckTip: '注:业务审核后将不允许修改, 待全部订单完成审核后，可以通过下方"一键查询"按钮进行失败订单查询。',
  SalesMapping: '销售映射：',
  SalesCargoSalesMap: '委托业务的销售映射到操作业务的揽货销售',
  BusinessRemarks: '业务备注',
  InternalEquipmentNote: '内装备注',
  QuantityWeightCubageConfirmed: '件毛体已确认',
  DataModifiedHasMergeContinueSave: '数据被[{0}]于{1}修改，已帮您合并，是否保存？',
  SyncYongYouNotCancelReview: '已推送过用友，不可取消审核',
  PrintByBusinessNumber: '按业务编号打印',
  SelectNotBelongToCurBranch: '所勾选的单据中有不属于当前分公司的业务单据，不可修改！',
  ClickFilePrivew: '点击文件名可预览文件',
  PackageDownload: '打包下载',
  CCPost: '抄送岗位',
  CCYourself: '抄送自己',
  SaveCcAddresNextDefault: '保存本次抄送岗位（用于下次默认带出）',
  ForMakingBatchTransferModifications: '业务编号{0}只勾选了小票信息未勾选主票信息，无法批量转船，请勾选对应的主票信息修改',
  TherePositionPleaseConfirmSuitable: '<b>{0}</b>岗位有多个可用选项，请确认当前所选人员合适。',
  TheWithBusinessStandardsSelection: '<b>{0}</b>岗位不符合业务规范，请重新选择。',
  PositionReSelectionReminder: '岗位重选提醒',
  LastEmailSentTime: '最后邮件发送时间',
  SendVerification: '发送校验',
  BusinessOfTheSelectedMatch: '业务验证异常：所选业务的{0}不一致',
  FeeReceivable: '费用(应收)',
  CostsPayable: '费用(应付)',
  TheThisBusinessCannotModified: '该业务的交货地不可修改',
  TheLoadingPOLCannotEmpty: '起运港(POL)不能为空',
  TheForThisShipmentModified: '该业务的起运港(POL)不可修改',
  TheDestinationCannotBeEmpty: '最终目的地不能为空',
  TheThisServiceCannotModified: '该业务的最终目的地不可修改',
  TheForThisServiceChanged: '该业务的卸货港(POD)不可修改',
  TheDischargePODCannotEmpty: '卸货港(POD)不能为空',
  ShippingTypeCannotBeEmpty: '揽货类型不能为空',
  InvalidCargoType: '无效的揽货类型',
  TheServiceHasBeenModified: '该业务的揽货类型已锁定，不可修改',
  TheForThisServiceModified: '该业务的揽货类型不可修改',
  TheForThisServiceModified2: '该业务的货物大类不可修改',
  TheIsNotAllowedChanges: '该业务的目的港代理不可修改',
  ListOfHazardousMaterials: '危险品列表',
  DangerousGoodsInformation: '危险品信息',
  CustomsProcedures: '报关操作',
  CarDispatchInformation: '派车信息',
  QuantityGrossWeightVolume: '件数/毛重/体积',
  CustomFormBusinessBooking: '自定义表单（业务订舱）',
  BusinessOperationInstruction: '【业务操作指令】',
  NonEditable: '不可编辑',
  BatchExportToImport: '批量出口转进口',
  NonSupportImportationThroughEntry: '非集团公司，不支持出口转进口',
  BatchProcessingForTheReselect: '批量出口转进口仅支持勾选相同目的港代理业务进行批量操作，请重新勾选！！',
  TheNotMeetTheConversion: '目的港代理、操作公司，不符合出口转进口的条件！',
  TheThePortAgentExist: '目的港代理的连接分公司不存在',
  NotForReExport: '不可出口转进口',
  ExportFunctionIsNotEnabled: '未开启出口转进口功能',
  BatchProgressPleaseReferBelow: '批量出口转进口执行中，详见下方执行结果！',
  TheDestinationPortAgentEmpty: '目的港代理的连接分公司不能为空！',
  PleaseAFeeToEdit: '请选择一条费用进行编辑',
  PleaseFeesYouWantDelete: '请选择需要删除的费用进行删除！',
  AreWantToDeleteExpense: '是否确定删除选中的费用？',
  ThisFeeIsNotEditable: '该费用不可编辑',
  TheNameCannotBeEmpty: '费用名称不能为空',
  BillUpTo3Currencies: '账单最多支持3种币种！'
}
